import './CaseStudy.scss';

import VideoEmbed from './VideoEmbed';
import poster from '../resources/images/case-vision-poster.webp';

// The one place on the page that shows rather than argues. Everything above it
// is a claim — people would rather watch, the ask lands better on film, here is
// what you'd make — and none of it was previously attached to a film anyone
// could actually watch. The reel in About is range; this is one job, start to
// finish, with what it was for.
//
// Sits directly after UseCases on purpose. That section ends on "the film that
// opens the event"; this is one, so the abstract case and the demonstration are
// adjacent rather than five sections apart. TakeAction and its CTA follow
// immediately, which is the order the funnel wants: proof, then urgency, then
// the ask. Deliberately carries no CTA of its own — About and TakeAction
// already close with one each, and three in a row is nagging.
//
// NO INVENTED NUMBERS. The facts below are what the client reported and no
// more. "Well above the year before" stays unquantified until there is a real
// figure St. Lawrence has agreed to have published — that is a data edit here,
// not a redesign. Note the phrasing: it states what the evening did, not that
// the film caused it. See CLAUDE.md.
const FACTS = [
    {
        label: "Who",
        body: "St. Lawrence Catholic Church & Newman Center, Minneapolis.",
    },
    {
        label: "The brief",
        body: `Announce a ten-year vision for the parish, and build interest ahead of
               the capital campaign that would fund it.`,
    },
    {
        label: "Where it played",
        body: `Premiered at the Spring Wine Social, the parish's largest fundraising
               event of the year.`,
    },
    {
        label: "That evening",
        body: "Giving came in well above the year before.",
    },
];

function CaseStudy() {
    return (
        <div className="CaseStudy" id="work">
            <div className="CaseStudy-header-container reveal">
                <span className="CaseStudy-eyebrow">Recent work</span>
                <h2 className="CaseStudy-header">
                    The film that <span>opened the night.</span>
                </h2>
                <p className="CaseStudy-lead">
                    A parish with ten years of plans to announce, one room to announce them
                    in, and one evening to do it.
                </p>
            </div>

            <div className="CaseStudy-video reveal delay-1">
                <VideoEmbed
                    youtubeID="efuIAlHcMpo"
                    poster={poster}
                    title="Ten-year vision film for St. Lawrence Catholic Church &amp; Newman Center"
                    label="Watch the film"
                    name="Parish vision film" />
            </div>

            <dl className="CaseStudy-facts reveal delay-2">
                {FACTS.map(fact => (
                    <div className="CaseStudy-fact" key={fact.label}>
                        <dt>{fact.label}</dt>
                        <dd>{fact.body}</dd>
                    </div>
                ))}
            </dl>
        </div>
    );
}

export default CaseStudy;
